__webpack_require__.p = "/storybook-standalone/onboarding/";